import { render, staticRenderFns } from "./nutritionApplyPlan.vue?vue&type=template&id=04f9a85c&scoped=true"
import script from "./nutritionApplyPlan.vue?vue&type=script&lang=js"
export * from "./nutritionApplyPlan.vue?vue&type=script&lang=js"
import style0 from "./nutritionApplyPlan.vue?vue&type=style&index=0&id=04f9a85c&prod&scoped=true&lang=css"
import style1 from "./nutritionApplyPlan.vue?vue&type=style&index=1&id=04f9a85c&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9a85c",
  null
  
)

export default component.exports